'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import t from 'prop-types';
import { useState, useRef, useMemo, Children, isValidElement, cloneElement } from 'react';
import { BreadcrumbList } from './breadcrumb-list.component.js';
import { useId } from '../../hooks/use-id.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, o) {
    return r in e ? Object.defineProperty(e, r, {
        value: o,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = o, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var o = null != arguments[r] ? arguments[r] : {}, t = Object.keys(o);
        "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
            return Object.getOwnPropertyDescriptor(o, e).enumerable;
        }))), t.forEach(function(r) {
            _define_property(e, r, o[r]);
        });
    }
    return e;
}
let b = {
    accessibleTextForMore: t.string
}, d = Object.keys(b), f = new Set([
    'swan-breadcrumbs'
]);
const Breadcrumbs = renderWithRef('Breadcrumbs', b, (o, p)=>{
    let [b, h] = useState(false), y = useId(), j = useRef(), w = useMemo(()=>Children.map(o.children, (e, r)=>{
            if (isValidElement(e)) {
                let o = e.props.id || (null != y ? y : 'breadcrumb-') + r;
                return 1 === r ? cloneElement(e, {
                    id: o,
                    ref: j
                }) : cloneElement(e, {
                    id: o
                });
            }
            return e;
        }), [
        o.children,
        y
    ]), O = Children.toArray(w), g = O.map((e)=>isValidElement(e) ? e.props.id : null);
    function showMore() {
        h(true), setTimeout(()=>{
            if (void 0 === j.current) return;
            let e = j.current;
            e.children && e.children.length > 0 && e.children[0].focus();
        }, 500);
    }
    return jsx(RenderComp, {
        root: "nav",
        forwardedRef: p,
        propKeysToRemove: d,
        classNames: f,
        props: _object_spread({}, o),
        children: o.accessibleTextForMore && g.length > 4 ? jsxs(BreadcrumbList, {
            className: b ? '' : 'swan-breadcrumbs-collapsed',
            children: [
                O[0],
                jsx("li", {
                    className: "swan-breadcrumbs-button-more",
                    children: jsx("button", {
                        "aria-label": o.accessibleTextForMore,
                        "aria-expanded": "false",
                        onClick: showMore,
                        "aria-controls": g.slice(1, -2).join(' '),
                        children: "..."
                    })
                }),
                O.slice(1)
            ]
        }) : jsx(BreadcrumbList, {
            children: w
        })
    });
});

export { Breadcrumbs };
